import Navbar from "./Navbar";
import { useTranslator } from "../../context/LanguageContext.js";
import Footer from "./Footer.jsx";

const galleryImages = [
  "a2.jpeg",
  "a3.jpeg",
  "a4.jpeg",
  "a5.jpeg",
  "a6.jpeg",
  "a7.jpeg",
  "a8.jpeg",
  "a9.jpeg",
  "a10.jpeg",
  "a11.jpeg",
  "a12.jpeg",
  "a13.jpeg",
  "a15.jpeg",
  "a16.jpeg",
  "g1.jpeg",
  "g3.jpeg",
  "g4.jpeg",
  "g5.jpeg",
  "g7.jpeg",
  "g8.jpeg",
  "g9.jpeg",
  "g10.jpeg",
  "g11.jpeg",
  "g12.jpeg",
  "g13.jpeg",
  "g14.jpeg",
  "g15.jpeg",
  "g16.jpeg",
  "g17.jpeg",
  "g18.jpeg",
  "g19.jpeg",
  "g20.jpeg",
  "g21.jpeg",
  "g22.jpeg",
  "g25.jpeg",
  "g28.jpeg",
  "g30.jpeg",
  "m1.jpeg",
  "m3.jpeg",
  "m4.jpeg",
  "m5.jpeg",
  "m6.jpeg"
];

export default function Activity() {
  const { t } = useTranslator();

  const getImageSrc = (filename) =>
    `${process.env.PUBLIC_URL}/Gallery/${filename}`;

  return (
    <>
      <Navbar />
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Noto+Sans+Devanagari:wght@400;500;600;700&display=swap');

*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
body{overflow-x:hidden;}
.act-root{font-family:'Inter','Noto Sans Devanagari',sans-serif;background:#f8fafc;color:#1e293b;min-height:100vh;}
.act-hero{background:linear-gradient(180deg,#eff6ff 0%,#f8fafc 100%);padding:85px 20px 60px;position:relative;overflow:hidden;text-align:center;}
.act-hero::before{content:"";position:absolute;width:260px;height:260px;background:rgba(59,130,246,0.08);border-radius:50%;top:-120px;right:-100px;}
.act-hero::after{content:"";position:absolute;width:240px;height:240px;background:rgba(37,99,235,0.05);border-radius:50%;bottom:-100px;left:-80px;}
.act-hero-badge{display:inline-flex;align-items:center;justify-content:center;background:#dbeafe;border:1px solid #bfdbfe;color:#2563eb;font-size:11px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;padding:6px 16px;border-radius:999px;margin-bottom:18px;position:relative;z-index:2;}
.act-hero-title{font-size:clamp(30px,5vw,44px);font-weight:800;color:#0f172a;line-height:1.2;position:relative;z-index:2;}
.act-hero-sub{margin-top:12px;font-size:15px;color:#475569;line-height:1.9;max-width:620px;margin-inline:auto;position:relative;z-index:2;}
.act-container{max-width:1000px;margin:0 auto;padding:34px 16px 60px;}
.act-gallery-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:22px;}
.act-gallery-card{background:#ffffff;border:1px solid #e2e8f0;border-radius:20px;overflow:hidden;box-shadow:0 5px 20px rgba(15,23,42,0.04);}
.act-gallery-image{display:block;width:100%;height:100%;min-height:220px;object-fit:cover;}
@media(max-width:768px){.act-hero{padding:70px 16px 50px;}.act-hero-title{font-size:34px;}.act-hero-sub{font-size:14px;max-width:100%;}.act-container{padding:28px 14px 45px;}}
@media(max-width:480px){.act-hero{padding:60px 14px 42px;}.act-hero-title{font-size:28px;line-height:1.3;}.act-hero-sub{font-size:13px;line-height:1.8;}.act-container{padding:22px 12px 38px;}}
`}</style>

      <div className="act-root">
        <div className="act-hero">
          <div className="act-hero-badge">{t('activity.hero.badge')}</div>
          <div className="act-hero-title">{t('activity.hero.title')}</div>
          <div className="act-hero-sub">{t('activity.hero.sub')}</div>
        </div>

        <div className="act-container">
          <div className="act-gallery-grid">
            {galleryImages.map((filename) => (
              <div key={filename} className="act-gallery-card">
                <img
                  src={getImageSrc(filename)}
                  alt={filename}
                  className="act-gallery-image"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
